import { render, staticRenderFns } from "./SpecialOverlay.vue?vue&type=template&id=6a6088fa"
import script from "./SpecialOverlay.vue?vue&type=script&lang=js"
export * from "./SpecialOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports